import classNames from "classnames";
import styles from "./StandsItem.module.scss";

export default function StandsItem({ children, isActive }) {
  return <div className={classNames(styles.m, { [styles.active]: isActive })}>{children}</div>;
}
